import {
    GET_ALL_RT_INVOICE_ATTACHMENT_TYPE,
    SET_ALL_RT_INVOICE_ATTACHMENT_TYPE,
    POST_RT_INVOICE_ATTACHMENT_TYPE,
    PUT_RT_INVOICE_ATTACHMENT_TYPE,
    DELETE_RT_INVOICE_ATTACHMENT_TYPE
} from '../../constants';
import { errorNotification, successNotification } from "../../../../utils/notification";
import { FINANCIAL_RT_ENDPOINT } from '../../constants/endpoint';
import { onError, onSuccess } from '../../../../utils/http';

export const getAllInvoiceAttachmentType = () => {
    return {
        type: GET_ALL_RT_INVOICE_ATTACHMENT_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/invoiceAttachmentType`
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                store.dispatch(setAllInvoiceAttachmentType(response.data));
                return response;
            })
        }
    };
};

export const setAllInvoiceAttachmentType = (data) => {
    return {
        type: SET_ALL_RT_INVOICE_ATTACHMENT_TYPE,
        payload: data
    };
};

export const postInvoiceAttachmentType = (tvaRate) => {
    return {
        type: POST_RT_INVOICE_ATTACHMENT_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/invoiceAttachmentType`,
            method: 'post',
            data: tvaRate
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "create_success");
                store.dispatch(getAllInvoiceAttachmentType());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "create_error");
                throw error;
            })
        }
    };
};

export const putInvoiceAttachmentType = (id, tvaRate) => {
    return {
        type: PUT_RT_INVOICE_ATTACHMENT_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/invoiceAttachmentType/${id}`,
            method: 'put',
            data: tvaRate
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "update_success");
                store.dispatch(getAllInvoiceAttachmentType());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "update_error");
                throw error;
            })
        }
    };
};

export const deleteInvoiceAttachmentType = (id) => {
    return {
        type: DELETE_RT_INVOICE_ATTACHMENT_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/invoiceAttachmentType/${id}`,
            method: 'delete'
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "delete_success");
                store.dispatch(getAllInvoiceAttachmentType());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', error.response.status === 409 ? "ressource_in_use_error" : "delete_error");
                throw error;
            })
        }
    };
};